const fs = require("fs");
const path = require("path");
const { getConfigPropertyValue } = require("./page-utils");
/**
 * Use correct log statement to write message either on server or client
 * If on server, use global log function from lib/log
 * If on client, use browser supported console.log functions
 */
const log = {
  info: (msg, isClientLogging = false) =>
    isControlOnServer() && !isClientLogging
      ? global.log.info(msg)
      : isClientLogging
      ? console.info(msg)
      : "",
  warn: (msg, isClientLogging = false) =>
    isControlOnServer() && !isClientLogging
      ? global.log.warn(msg)
      : isClientLogging
      ? console.warn(msg)
      : "",
  error: (msg, isClientLogging = false) =>
    isControlOnServer() && !isClientLogging
      ? global.log.error(msg)
      : isClientLogging
      ? console.error(msg)
      : "",
  debug: (msg, isClientLogging = false) =>
    isControlOnServer() && !isClientLogging
      ? global.log.debug(msg)
      : isClientLogging
      ? console.debug(msg)
      : ""
};
exports.log = log;

/**
 * This method is used to read file defined in config folder
 * @param {String} file name
 * @returns {String} file content
 */
const readConfig = (file) => {
  const configDir = path.join(process.cwd(), "config");
  const fullPath = path.join(configDir, file);
  const content = fs.readFileSync(fullPath, "utf8");
  return content;
};

/**
 * Check if the control is on server or client side
 * @returns {boolean} true if control is on server, false if on client
 */
const isControlOnServer = () => {
  return typeof window === "undefined";
};

/**
 * @description - check if preview is enabled.
 * @param  {object} query - Query string section of URL parsed as an object
 * @return {boolean} preview flag
 */
const isPreviewRequest = ({ query }) => {
  const { slug } = query;
  if (!slug) return false;
  log.info(`Preview path parameter : ${slug[0] === "preview"}`);
  return slug[0] === "preview";
};

/**
 * @description Check if variation query parameters exists and retruns it value
 * @param {object} query - Query string section of URL parsed as an object
 * @returns {boolean} true/false
 */
const isVariationRequest = ({ query }) => {
  const isVariation = query.variation
    ? query.variation.toString().toLowerCase() === "true"
      ? true
      : false
    : false;
  log.info(`Variation parameter : ${isVariation}`);
  return isVariation;
};

/**
 * Method to check if the request is based on cas id
 * e.g. https://renderingservice.api.intuit.com/page/casid/cd829d/s
 * @param {query object} query
 * @returns {boolean}
 */
const isRequestByCasId = ({ query }) => {
  const { slug } = query;
  log.info(`Slug Val : ${slug}`);
  if (!slug) return false;
  log.info(`Variation parameter : ${slug[0] === "casid"}`);
  return slug[0] === "casid";
};

/**
 * Retrive value for given key from the site configuration
 * @param {String} Sitename e.g. SBSEG_QuickBooks_MKTG_US_en-US (BU_product_sitename_locale)
 * @param {String} key
 * @param {String} default value if config not available
 */
const getSiteConfig = (siteName, key, defaultValue) => {
  return getConfigPropertyValue({
    siteConfig: global.siteConfig,
    siteName,
    key,
    defaultValue,
    log
  });
};

function getPermalinkReplacement(siteName, logTrace) {
  let replacement = getSiteConfig(
    siteName,
    "premalink_replacement",
    "",
    logTrace
  );
  return (!!replacement && `${replacement}/`) || replacement;
}

function getSiteGeo(siteName, logTrace) {
  let geo =
    (getSiteConfig(siteName, "default_site", false, logTrace) && "") ||
    `${getSiteConfig(siteName, "rendering_prefix", "", logTrace)}`;
  return (geo && `/${geo}/`) || "/";
}

/**
 * Checks if the value is true
 * @param {String or boolean} value
 * @returns {boolean}
 */
const isTrue = (value) => {
  return (
    value &&
    value !== null &&
    (value === true || value.toString().toLowerCase() === "true")
  );
};

/**
 * checks of the object is empty, null or with no keys
 * @param {object} obj
 * @returns {boolean} True if empty
 */
const isEmptyObject = (obj) => {
  return !(obj && typeof obj === "object" && Object.keys(obj).length !== 0);
};

/**
 * Retrieve Business unit from sitename
 * @param {string} inputString - Sitename as underscore string e.g. SBSEG_QuickBooks_MKTG_US_en-US
 * @param {number} index - Position of value in given string with 0th been first position.
 * @return {string} Lower-case string value or empty string
 */
const retrieveBusinessUnit = (inputString = "", index = 0) => {
  return inputString ? inputString.toLowerCase().split("_")[index] : "";
};

/**
 * Reads cookie value using cookie name
 * @param {string} cname
 * @returns {string} cookie value
 */
const getCookie = (cname) => {
  const cvalue = document.cookie.match(new RegExp(cname + "=([^;]+)"));
  if (cvalue) return cvalue[1];
  return "";
};

/**
 * creates UUID
 */
const createUUID = () => {
  var lut = [];
  for (var i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? "0" : "") + i.toString(16);
  }
  var d0 = (Math.random() * 0xffffffff) | 0;
  var d1 = (Math.random() * 0xffffffff) | 0;
  var d2 = (Math.random() * 0xffffffff) | 0;
  var d3 = (Math.random() * 0xffffffff) | 0;
  return (
    lut[d0 & 0xff] +
    lut[(d0 >> 8) & 0xff] +
    lut[(d0 >> 16) & 0xff] +
    lut[(d0 >> 24) & 0xff] +
    "-" +
    lut[d1 & 0xff] +
    lut[(d1 >> 8) & 0xff] +
    "-" +
    lut[((d1 >> 16) & 0x0f) | 0x40] +
    lut[(d1 >> 24) & 0xff] +
    "-" +
    lut[(d2 & 0x3f) | 0x80] +
    lut[(d2 >> 8) & 0xff] +
    "-" +
    lut[(d2 >> 16) & 0xff] +
    lut[(d2 >> 24) & 0xff] +
    lut[d3 & 0xff] +
    lut[(d3 >> 8) & 0xff] +
    lut[(d3 >> 16) & 0xff] +
    lut[(d3 >> 24) & 0xff]
  );
};

/**
 * Rounds off float number string to fixed decimals
 * @param {any} float Float as a string or float
 * @param {Number} decimals - number of decimal places to be rounded off to
 * @returns {any}
 */
const parseFloatToFixedDecimals = (float, decimals) => {
  if (!isNaN(float)) {
    var num = parseFloat(float);
    return num.toFixed(decimals);
  }
  return float;
};

/**
 * checks if null or undefined variable
 * @param {string} val
 * @returns {boolean} true if null or undefined, false otherwise
 */
const isNullOrUndefined = (val) => {
  return (
    typeof val === "undefined" ||
    val === undefined ||
    val === null ||
    val === ""
  );
};

/**
 * convert hrtime bigint nanoseconds to milliseconds.
 * @param {hrtime} bigint in nanoseconds
 * @returns {bigint} bigint in milliseconds
 */
const convertHsTimeToMs = (hrtime) => {
  try {
    return hrtime / BigInt(1000000);
  } catch (error) {
    return null;
  }
};

const constructSiteName = (
  businessUnit,
  product,
  siteType,
  jurisdiction,
  language
) => {
  let siteName = "";
  if (businessUnit && product && siteType && jurisdiction && language) {
    siteName = `${businessUnit}_${product}_${siteType}_${jurisdiction}_${language.replace(
      "_",
      "-"
    )}`;
  }
  return siteName;
};

const getCombinedCssLevel = (siteName) => {
  return getSiteConfig(siteName, "combined_css_level", "molecule");
};

/**
 * This method applies callback async 'cb' on each property of the object 'obj', by
 * listing all properties using entries and converting back to object using
 * fromEntries. Promise.all is needed to await the cb execution.
 * @param {object} obj
 * @param {*} cb e.g. async ([_, value]) => await [_, (value * 2)] // twoMultiplierAsyncCb
 * @returns object with callback cb applied to each property
 */
const applyAsyncCallbackToObjectEntries = async (obj, cb) => {
  return Object.fromEntries(await Promise.all(Object.entries(obj).map(cb)));
};

/**
 * This method applies callback 'cb' on each property of the object 'obj', by
 * listing all properties using entries and converting back to object using
 * fromEntries.
 * @param {object} obj
 * @param {*} cb e.g. ([_, value]) => [_, (value * 2)] // twoMultiplierCb
 * @returns object with callback cb applied to each property
 */
const applyCallbackToObjectEntries = (obj, cb) => {
  return Object.fromEntries(Object.entries(obj).map(cb));
};

const getTheme = (renderingMetadata) => {
  const isServer = typeof window === "undefined";
  // IS_BUSINESS_UNIT_CG is only evaluated server-side; on the client it always
  // falls through to the getSiteConfig path. Client-side theme resolution reads
  // from document.body[data-theme] (set server-side) rather than calling getTheme.
  const IS_BUSINESS_UNIT_CG = isServer
    ? require("../../config").IS_BUSINESS_UNIT_CG
    : false;
  if (IS_BUSINESS_UNIT_CG) {
    return "turbotaxmarketing";
  }
  const theme = getSiteConfig(
    renderingMetadata.siteName,
    "theme",
    "quickbooks"
  );
  return theme;
};

// TODO: Remove this function once FAQ page has canonical field on WP
/**
 * Get SEO canonical URL
 * @param {String} seoCanonicalURL - SEO canonical URL from thirdPartyMetadata
 * @param {Object} req - Express request object
 * @returns {String} Canonical URL
 */
const getCanonicalURL = (seoCanonicalURL, siteName, pathname, logTrace) => {
  log.info(
    `${logTrace};EVENT_NAME=GENERATE_CANONICAL_URL_INITIATED; seoCanonicalURL=${seoCanonicalURL}; siteName=${siteName}; pathname=${pathname};`
  );
  // If seoCanonicalURL exists, return it
  if (seoCanonicalURL) {
    return seoCanonicalURL;
  }
  const pageDomain = getSiteConfig(siteName, "page_domain", "", logTrace);
  // If pageDomain and pathname exists, return it
  if (pageDomain && pathname) {
    log.info(
      `${logTrace};EVENT_NAME=GENERATE_CANONICAL_URL_COMPLETE; canonicalURL=${`${pageDomain}${pathname}`};`
    );
    return `${pageDomain}${pathname}`;
  }

  log.info(
    `${logTrace};EVENT_NAME=GENERATE_CANONICAL_URL_COMPLETE; canonicalURL=${""};`
  );
  return "";
};

const maskSensitiveHeaders = (headers) => {
  if (!headers || typeof headers !== "object") {
    return headers;
  }

  const maskedHeaders = { ...headers };

  // List of header keys that should be masked
  const sensitiveHeaderKeys = [
    "authorization",
    "cookie",
    "intuit_clientcontext",
    "ticket",
    "tkt",
    "ticketid",
    "ticket_id",
    "tktid",
    "tkt_id",
    "qbn",
    "token",
    "x-auth-token",
    "x-api-key",
    "api-key"
  ];

  // Mask sensitive headers
  Object.keys(maskedHeaders).forEach((key) => {
    const headerValue = maskedHeaders[key];

    // Skip null, undefined, or empty string values (they're not sensitive)
    if (!maskedHeaders[headerValue]) {
      return;
    }

    const lowerKey = key.toLowerCase();
    const value = String(headerValue);

    // Check if key matches any sensitive header pattern
    const isSensitive = sensitiveHeaderKeys.some((sensitiveKey) =>
      lowerKey.includes(sensitiveKey)
    );

    // Check if value contains ticket pattern
    const ticketPattern = /V1-\d+-[0-9a-zA-Z]{22}/gi;
    const hasTicketPattern = ticketPattern.test(value);

    // If header is sensitive by name, always mask the entire value
    if (isSensitive) {
      // Mask the value - show only first 4 chars if longer than 8, otherwise show length
      if (value.length > 8) {
        maskedHeaders[key] = `${value.substring(0, 4)}${"*".repeat(
          value.length - 4
        )}`;
      } else {
        maskedHeaders[key] = "*".repeat(value.length);
      }
    } else if (hasTicketPattern) {
      // If not a sensitive header by name but contains ticket pattern, mask only the ticket
      maskedHeaders[key] = value.replace(
        ticketPattern,
        "V1-***-**********************"
      );
    }
    // Otherwise leave the value as-is
  });

  return maskedHeaders;
};

const defaultLocale = "en_US";

/**
 * Resolves the JSON-LD schema markup for injection into the page <head>.
 * `metaData.seoSchemaGenerationMarkup` already arrives as a full
 * `<script type="application/ld+json">{...}</script>` tag (the {{jsonLDSchema}}
 * variable resolved upstream). We do NOT rebuild or re-expand the tag - we read
 * the tag's own attributes (type, id, ...) and its inner content straight from
 * the supplied markup and return them, so layout can render a single <script>
 * that preserves those original attributes. We only verify the value is a
 * <script> tag and that its inner content is valid schema; malformed markup is
 * logged and skipped (returns null) rather than breaking the page, and any
 * `</script` sequence is escaped so it is safe as a <script> child. Pure string
 * logic, safe on server and client.
 * @param {string} markup - seoSchemaGenerationMarkup from metaData
 * @param {string} logTrace
 * @returns {{attributes: object, schema: string}|null} the tag's attributes and
 *   inner schema, or null if absent/invalid
 */
const resolveJsonLdSchemaInHead = (markup, logTrace = "") => {
  if (markup === undefined || markup === null || markup === "") {
    log.debug(`${logTrace};EVENT_NAME=JSONLD_SCHEMA_NOT_PRESENT;`);
    return null;
  }
  try {
    const trimmed = markup.trim();
    // The value must already be a full <script ...>...</script> tag.
    const match = trimmed.match(/^<script\b([^>]*)>([\s\S]*)<\/script>\s*$/i);
    if (!match) {
      log.error(
        `${logTrace};EVENT_NAME=JSONLD_SCHEMA_PARSE_FAILED; error=markup is not a <script> tag;`
      );
      return null;
    }
    // Preserve the tag's own attributes (id, type, ...); default the type only
    // when the tag does not provide one.
    const attributes = parseHtmlAttributes(match[1]);
    if (!attributes.type) {
      attributes.type = "application/ld+json";
    }
    const schema = match[2].trim();
    log.info(`${logTrace};EVENT_NAME=JSONLD_SCHEMA_INJECTED;`);
    // Return the tag's original attributes and inner JSON (escaped) - no rebuild.
    return { attributes, schema: schema.replace(/<\/(script)/gi, "<\\/$1") };
  } catch (err) {
    // Log and skip rather than break the page on malformed markup.
    // Only the error message is logged, never the markup payload.
    log.error(
      `${logTrace};EVENT_NAME=JSONLD_SCHEMA_PARSE_FAILED; error=${err.message};`
    );
    return null;
  }
};

/**
 * Parses an HTML attribute string (the part inside a tag's angle brackets,
 * e.g. ` type="application/ld+json" id="schema-1"`) into a key/value object.
 * Only well-formed `key="value"` / `key='value'` pairs are captured.
 * @param {string} attrString
 * @returns {object}
 */
const parseHtmlAttributes = (attrString = "") => {
  const attributes = {};
  const attrRegex = /([a-zA-Z_:][-a-zA-Z0-9_:.]*)\s*=\s*"([^"]*)"|([a-zA-Z_:][-a-zA-Z0-9_:.]*)\s*=\s*'([^']*)'/g;
  let match;
  while ((match = attrRegex.exec(attrString)) !== null) {
    const key = match[1] || match[3];
    const value = match[2] !== undefined ? match[2] : match[4];
    attributes[key] = value;
  }
  return attributes;
};

module.exports = {
  readConfig,
  isControlOnServer,
  log,
  isPreviewRequest,
  getSiteConfig,
  isTrue,
  retrieveBusinessUnit,
  isVariationRequest,
  isRequestByCasId,
  isEmptyObject,
  getCookie,
  createUUID,
  parseFloatToFixedDecimals,
  isNullOrUndefined,
  convertHsTimeToMs,
  constructSiteName,
  defaultLocale,
  getCombinedCssLevel,
  applyAsyncCallbackToObjectEntries,
  applyCallbackToObjectEntries,
  getPermalinkReplacement,
  getSiteGeo,
  getTheme,
  getCanonicalURL,
  maskSensitiveHeaders,
  resolveJsonLdSchemaInHead
};
